export function emailValidation(email) {
    // This regexp is close to the default django email validator that pyvar uses.
    // It only accepts "normal" addresses without accented characters.
    return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email);
}

export function capitalizeFirstLetter(string) {
    if (!string || string.length === 0) {
        return '';
    }

    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
